module.exports = __webpack_public_path__ + "img/c_2.de1131f4.png";